<template>
  <Layout>
    <LayoutAppLayout>
      <div class="static">
        <slot />
      </div>
    </LayoutAppLayout>
  </Layout>
</template>

<style scoped lang="scss">
  .static {
    max-width: $vgs-max-width-content-medium;
    margin: 0 auto;
  }

  :deep(p) {
    margin-bottom: 2rem;
  }
</style>
